import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-836525c4")

_pushScopeId("data-v-836525c4")
const _hoisted_1 = { class: "parent-card p-d-flex p-flex-column" }
const _hoisted_2 = { class: "flex-grow overflow-auto" }
const _hoisted_3 = { class: "p-grid p-m-0" }
const _hoisted_4 = { class: " p-col-3" }
const _hoisted_5 = {
  key: 0,
  class: "p-d-flex p-jc-center p-ai-center"
}
const _hoisted_6 = { class: "p-d-flex p-mx-3" }
const _hoisted_7 = { class: "p-text-bold p-text-center p-large" }
const _hoisted_8 = { class: "p-d-flex p-flex-column p-t-2" }
const _hoisted_9 = { class: "p-text-left p-text-bold p-m-1 " }
const _hoisted_10 = { class: "p-text-left p-m-1" }
const _hoisted_11 = {
  key: 1,
  class: "p-d-flex p-jc-center p-ai-center"
}
const _hoisted_12 = { class: "p-d-flex" }
const _hoisted_13 = {
  key: 2,
  class: "p-d-flex p-jc-center p-ai-center"
}
const _hoisted_14 = { class: "p-d-flex" }
const _hoisted_15 = { class: "p-col-9" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_SelectButton = _resolveComponent("SelectButton")
  const _component_Column = _resolveComponent("Column")
  const _component_Badge = _resolveComponent("Badge")
  const _component_Button = _resolveComponent("Button")
  const _component_DataTable = _resolveComponent("DataTable")
  const _component_Card = _resolveComponent("Card")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("span", {
      class: "p-d-flex flex-no-grow p-mx-2",
      style: _ctx.schedulationAgendaDescriptor.span.style
    }, [
      _createVNode(_component_SelectButton, {
        class: "p-m-1",
        modelValue: _ctx.selectedDisplayMode,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectedDisplayMode = $event)),
        options: _ctx.displayModes,
        optionLabel: "name",
        "data-test": "select-button"
      }, null, 8, ["modelValue", "options"])
    ], 4),
    _createVNode("div", _hoisted_2, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.groupedItemList, (dataItem) => {
        return (_openBlock(), _createBlock(_component_Card, {
          key: dataItem,
          class: "p-mx-3 p-my-1"
        }, {
          content: _withId(() => [
            _createVNode("div", _hoisted_3, [
              _createVNode("div", _hoisted_4, [
                (_ctx.displayMode === 'time')
                  ? (_openBlock(), _createBlock("div", _hoisted_5, [
                      _createVNode("div", _hoisted_6, [
                        _createVNode("p", _hoisted_7, _toDisplayString(dataItem.day), 1)
                      ]),
                      _createVNode("div", _hoisted_8, [
                        _createVNode("p", _hoisted_9, _toDisplayString(dataItem.dayOfWeek), 1),
                        _createVNode("p", _hoisted_10, _toDisplayString(dataItem.monthName + ' ' + dataItem.year), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.displayMode === 'package')
                  ? (_openBlock(), _createBlock("div", _hoisted_11, [
                      _createVNode("div", _hoisted_12, [
                        _createVNode("h2", null, _toDisplayString(dataItem.jobName), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.displayMode === 'document')
                  ? (_openBlock(), _createBlock("div", _hoisted_13, [
                      _createVNode("div", _hoisted_14, [
                        _createVNode("h2", null, _toDisplayString(dataItem.document), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createVNode("div", _hoisted_15, [
                _createVNode(_component_DataTable, {
                  value: dataItem.executions,
                  expandedRows: _ctx.expandedRows,
                  "onUpdate:expandedRows": _cache[2] || (_cache[2] = ($event: any) => (_ctx.expandedRows = $event)),
                  class: "custom-row-border p-datatable-sm kn-table",
                  dataKey: "id",
                  rows: 10,
                  rowClass: _ctx.rowClass,
                  responsiveLayout: "stack",
                  breakpoint: "960px",
                  "data-test": "data-table"
                }, {
                  empty: _withId(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('common.info.noDataFound')), 1)
                  ]),
                  expansion: _withId((slotProps) => [
                    _createVNode("div", null, [
                      _createVNode(_component_DataTable, {
                        value: slotProps.data.documents
                      }, {
                        default: _withId(() => [
                          _createVNode(_component_Column, null, {
                            body: _withId(() => [
                              _createVNode(_component_Button, {
                                icon: "pi pi-book",
                                class: "p-button-link"
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_Column, {
                            style: _ctx.schedulationAgendaDescriptor.table.iconColumn.style
                          }, {
                            body: _withId(() => [
                              _createVNode(_component_Button, {
                                icon: "pi pi-document",
                                class: "p-button-link"
                              })
                            ]),
                            _: 1
                          }, 8, ["style"]),
                          _createVNode(_component_Column, null, {
                            body: _withId((slotProps) => [
                              _createTextVNode(_toDisplayString(slotProps.data), 1)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1032, ["value"])
                    ])
                  ]),
                  default: _withId(() => [
                    _createVNode(_component_Column, {
                      field: "date",
                      style: _ctx.schedulationAgendaDescriptor.table.dateColumn.style
                    }, {
                      body: _withId((slotProps) => [
                        (_ctx.displayMode == 'time')
                          ? (_openBlock(), _createBlock("div", {
                              key: 0,
                              class: "p-pl-1 color-left-border",
                              style: { borderLeftColor: _ctx.getRandomColor(slotProps.data.jobName) }
                            }, _toDisplayString(new Date(slotProps.data.date).toLocaleString(_ctx.getLocale(true), { hour: '2-digit', minute: '2-digit' })), 5))
                          : _createCommentVNode("", true),
                        (_ctx.displayMode == 'package' || _ctx.displayMode == 'document')
                          ? (_openBlock(), _createBlock("div", {
                              key: 1,
                              class: "p-pl-1 color-left-border",
                              style: { borderLeftColor: _ctx.getRandomColor(slotProps.data.jobName) }
                            }, _toDisplayString(slotProps.data.date), 5))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }, 8, ["style"]),
                    _createVNode(_component_Column, { field: "jobName" }),
                    _createVNode(_component_Column, {
                      field: "numberOfDocuments",
                      style: _ctx.schedulationAgendaDescriptor.table.badgeColumn.style
                    }, {
                      body: _withId((slotProps) => [
                        _createVNode(_component_Badge, {
                          value: slotProps.data.numberOfDocuments
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    }, 8, ["style"]),
                    _createVNode(_component_Column, {
                      style: _ctx.schedulationAgendaDescriptor.table.rowExpanderColumn.style,
                      expander: true
                    }, null, 8, ["style"]),
                    _createVNode(_component_Column, {
                      style: _ctx.schedulationAgendaDescriptor.table.iconColumn.style
                    }, {
                      body: _withId((slotProps) => [
                        _createVNode(_component_Button, {
                          icon: "pi pi-pencil",
                          class: "p-button-link",
                          onClick: ($event: any) => (_ctx.openRedirection(slotProps.data.jobName)),
                          "data-test": 'action-button'
                        }, null, 8, ["onClick"])
                      ]),
                      _: 1
                    }, 8, ["style"])
                  ]),
                  _: 2
                }, 1032, ["value", "expandedRows", "rowClass"])
              ])
            ])
          ]),
          _: 2
        }, 1024))
      }), 128))
    ])
  ]))
})